import Seo from "@/components/Seo";

export default function About() {
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "Person",
        name: "J. Erwin",
        url: "https://afincalc.com/about",
        jobTitle: "Founder & Editor",
        worksFor: { "@type": "Organization", name: "FinCalc", url: "https://afincalc.com" },
        description: "Engineer and software developer with experience in financial tools, data automation, and SaaS product development.",
        knowsAbout: ["Personal finance", "Mortgage calculations", "Debt payoff strategies", "Retirement planning", "Tax calculations"],
    };

    return (
        <>
            <Seo
                title="About FinCalc — Free, honest finance calculators"
                description="FinCalc was built by an engineer who got tired of finance sites that bury the math behind lead forms. Free, accurate calculators — no upsell."
                canonical="/about"
                jsonLd={jsonLd}
            />
            <section className="container-editorial py-16 max-w-3xl anim-fade-up">
                <div className="text-[11px] uppercase tracking-[0.2em] text-accent">About</div>
                <h1 className="font-serif text-5xl lg:text-6xl text-primary mt-3 leading-tight">
                    Honest math. No upsell.
                </h1>
                <div className="mt-8 prose-editorial">
                    <p>
                        FinCalc is a library of free, fast, accurate finance calculators. It was
                        built because every major financial decision — what mortgage you can
                        afford, when you'll be debt free, whether you'll retire
                        comfortably — deserves a clean, unambiguous answer. Not a newsletter
                        signup. Not a lead capture form. Not "get a quote."
                    </p>

                    <h2>Who built this</h2>
                    <p>
                        FinCalc was created by <strong>J. Erwin</strong>, an engineer and software
                        developer based in Central Texas with a background in systems integration,
                        data automation, and SaaS product development. After years of watching
                        finance sites optimize for lead generation instead of accuracy, the goal
                        was simple: build a calculator site where the math is right, the
                        assumptions are visible, and nothing is hidden behind a form.
                    </p>
                    <p>
                        FinCalc is a product of <strong>Hi Tex Lawn Pro LLC</strong>, an
                        Austin-area technology and software company.
                    </p>

                    <h2>What we do</h2>
                    <p>
                        We maintain 20+ calculators covering the most common money
                        questions people ask the internet. Every calculator runs in your browser —
                        we don't store what you type. The math is open, the assumptions are
                        printed right next to the result. If a number looks wrong, we want to
                        hear about it — we publish corrections.
                    </p>

                    <h2>How we're funded</h2>
                    <p>
                        FinCalc is funded by display advertising — the small labeled ad
                        placements you see on calculator pages. That's it. We don't sell
                        your data, take affiliate kickbacks from specific lenders, or optimize
                        calculations to steer you toward a product.
                    </p>

                    <h2>What we are not</h2>
                    <p>
                        FinCalc is <strong>not</strong> financial, tax, or legal advice. We build
                        tools that help you run the numbers. Consult a licensed professional
                        before making a material financial decision.
                    </p>

                    <h2>Contact</h2>
                    <p>
                        Questions, corrections, or feedback — use the{" "}
                        <a href="/contact" className="text-primary hover:underline">contact page</a>.
                        We read every message and respond to substantive questions.
                    </p>
                </div>
            </section>
        </>
    );
}